/**
 * Manages user-specific settings which are currently stored in the local storage (browser).
 * User settigns are mostly UI, such as default selections, filters, column orders, etc.
 * Later implementations may store the settings in the server do that they transfer from one browser to another
 * within the same user.
 */
export class UserSettingsService {

  private settings: { [key: string]: any };

  /**
   * Returns an object with one property "val" that is bound to the given key.
   * Used for easier data binding in AngularJS models.
   * @param key Key for the property.
   * @returns An object with one property "val" that is bound to the given key (getter and setter).
   * @example
   * <salaxy-input-boolean name="myInput" ng-model="$ctrl.userSettings.ng1Binder('payroll.newVersion').val" label="Uusi versio"></salaxy-input>
   */
  public ng1Binder(key: string) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this; // Cannot use lambda in getter/setter. Other warkarounds to preserve "this" would probably be more complex.
    return {
      /** Property the is bound to the given key. */
      get val() {
        return that.get(key);
      },
      set val(value: any) {
        that.set(key, value);
      }
    };
  }

  /**
   * Gets a setting value from local storage
   * @param key String key for the value
   * @returns The value
   */
  public get<T>(key: string): T {
    key = key.toLowerCase().trim();
    return this.getAll()[key];
  }

  /**
   * Sets a setting value to local sotrage
   * @param key String key for the value
   * @param value The value.
   */
  public set<T>(key: string, value: T): void {
    key = key.toLowerCase().trim();
    if (!key) {
      throw new Error("Key cannot be empty");
    }
    const all = this.getAll();
    all[key] = value;
    this.setAll(all);
  }

  private getAll(): { [key: string]: any } {
    if (!this.settings) {
      if (!localStorage["salaxy-user-settings"]) {
        localStorage["salaxy-user-settings"] = JSON.stringify({});
      }
      this.settings = JSON.parse(localStorage["salaxy-user-settings"]);
    }
    return this.settings;
  }

  private setAll(settings: { [key: string]: any }): void {
    localStorage["salaxy-user-settings"] = JSON.stringify(settings);
    this.settings = settings;
  }

}